import "core-js";
import Form from './src/Form';
import extendPhone from './custom_rules/phone';
import extendIban from './custom_rules/iban';
import extendSSNFr from './custom_rules/securiteSocialeFr';
import i18n from './src/i18n';
import extendUnique from './custom_rules/unique';
import VeeValidate, { Validator } from 'vee-validate';
import {version} from './package.json';

import track from './src/sessionTracking';

console.log("LUCIEN.AI FORM BUILDER", version);

import fr from 'vee-validate/dist/locale/fr';
import es from 'vee-validate/dist/locale/es';
import en from 'vee-validate/dist/locale/en';
import de from 'vee-validate/dist/locale/de';
import nl from 'vee-validate/dist/locale/nl';
import pl from 'vee-validate/dist/locale/pl';

fr.custom = i18n.fr.VeeValidate.custom;
fr.attributes = i18n.fr.VeeValidate.attributes;
en.custom = i18n.uk.VeeValidate.custom;
en.attributes = i18n.uk.VeeValidate.attributes;
es.custom = i18n.es.VeeValidate.custom;
es.attributes = i18n.es.VeeValidate.attributes;
de.custom = i18n.de.VeeValidate.custom;
de.attributes = i18n.de.VeeValidate.attributes;
nl.custom = i18n.nl.VeeValidate.custom;
nl.attributes = i18n.nl.VeeValidate.attributes;
pl.custom = i18n.pl.VeeValidate.custom;
pl.attributes = i18n.pl.VeeValidate.attributes;

export default {
  Form,
  track,
  install (Vue) {
    Vue.use(VeeValidate);
    Vue.component('Form', Form);
    Validator.localize({fr,es,de,nl,pl});
    Validator.localize('fr');

    extendPhone(Validator);
    extendIban(Validator);
    extendSSNFr(Validator);
    extendUnique(Validator);
  }
};
